// extracted by mini-css-extract-plugin
export default {"root":"Tab_root__zooH6","active":"Tab_active__gmVR3","animated":"Tab_animated__DcinU","movingRight":"Tab_movingRight__8+-A4"};